import { unitId } from '@/annotations'

/**
 * `v-blocked` — process/09-SCREEN-SPECS/v-blocked.md. **`NO_OPERATION`** — the rendered
 * `ORG_BLOCKED` refusal itself, a client route from §3.1j's table rather than a read (rule 1).
 * Names **no reason and no error code** — the block reason is an internal column, not customer
 * copy (rule 2, `D75`) — and offers no retry that would simply be refused again (rule 3).
 */
export function VBlocked() {
  return (
    <div data-scr={unitId('v-blocked')}>
      <h1 className="m-0 mb-4 text-section font-semibold">Access to this organisation is blocked</h1>
      <p className="text-tx2">Switch to another organisation from the switcher above, or contact whoever administers this one.</p>
    </div>
  )
}
